import { Pipe, PipeTransform } from '@angular/core';
import { RoomPriceOption } from '@rx-applications/clientsite/shared/utils';
import { isAfter, parseISO } from 'date-fns';

@Pipe({
  name: 'isRefundable',
  standalone: true,
})
export class IsRefundablePipe implements PipeTransform {
  transform(roomPriceOption: RoomPriceOption): boolean | null {
    //This pie is created based on the roomCancellationPolicy$ effect
    //from libs\clientsite\search\hotel\data-access\src\lib\store\facade\rooms.facade.ts
    const terms = roomPriceOption?.terms;
    const rightNow = new Date();
    const isBeforeTermsStart = terms && !terms.inTerms && isAfter(new Date(parseISO(terms.termsStartAt)), rightNow);
    return isBeforeTermsStart;
  }
}
